import { render, staticRenderFns } from "./adminHeader.vue?vue&type=template&id=35986064&scoped=true&"
import script from "./adminHeader.vue?vue&type=script&lang=js&"
export * from "./adminHeader.vue?vue&type=script&lang=js&"
import style0 from "./adminHeader.vue?vue&type=style&index=0&id=35986064&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35986064",
  null
  
)

export default component.exports